<template lang="html">
  <div class="container" id="text-page">

    <h1 class="page-title txt-black">AVISO DE PRIVACIDAD INTEGRAL</h1>

    <p>Sociedad, Gal, Comercial y Producción, S.A. de C.V., en lo sucesivo “la Empresa”, es responsable del uso y protección de sus datos personales, en cumplimiento con lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y su Reglamento.</p>

    <p>Para efectos comerciales, la Empresa opera bajo el nombre comercial Legacy Timepieces, marca bajo la cual se ofrecen productos y servicios relacionados con la compraventa, intermediación, promoción y difusión de relojería de lujo y artículos afines.</p>

    <br />
    <h5>1. IDENTIDAD Y DOMICILIO DEL RESPONSABLE</h5>

    <p>El responsable del tratamiento de sus datos personales es Sociedad, Gal, Comercial y Producción, S.A. de C.V., quien los tratará conforme a este Aviso de Privacidad y a la normatividad aplicable.</p>

    <p>Para cualquier asunto relacionado con este Aviso de Privacidad, puede contactarnos a través de los medios que se indiquen en el apartado de contacto del sitio web operado bajo el nombre comercial Legacy Timepieces.</p>

    <br />
    <h5>2. DATOS PERSONALES QUE SE RECABAN</h5>

    <p>Los datos personales que podemos recabar incluyen, de manera enunciativa mas no limitativa:</p>
    <ul>
        <li>Nombre completo</li>
        <li>Teléfono</li>
        <li>Correo electrónico</li>
        <li>Información de contacto</li>
        <li>Datos fiscales (cuando aplique)</li>
        <li>Información necesaria para procesos de compra, venta, facturación, rifas, eventos o atención al cliente</li>
    </ul>

    <p>En ningún caso se recabarán datos personales sensibles sin su consentimiento expreso.</p>

    <br />
    <h5>3. FINALIDADES DEL TRATAMIENTO DE LOS DATOS</h5>

    <p>Finalidades primarias, necesarias para la relación jurídica y comercial:</p>
    <ul>
        <li>Identificarlo como cliente, prospecto o participante</li>
        <li>Contactarlo para dar seguimiento a solicitudes, compras o servicios</li>
        <li>Procesar operaciones comerciales, administrativas y fiscales</li>
        <li>Cumplir obligaciones legales y contractuales</li>
    </ul>

    <p>Finalidades secundarias, de carácter opcional:</p>
    <ul>
        <li>Envío de información comercial, promociones, novedades o eventos</li>
        <li>Mercadotecnia, publicidad y prospección comercial</li>
        <li>Análisis estadísticos internos</li>
    </ul>

    <p>Si no desea que sus datos sean tratados para las finalidades secundarias, puede manifestarlo mediante los medios de contacto indicados en este Aviso.</p>

    <br />
    <h5>4. TRANSFERENCIA DE DATOS PERSONALES</h5>

    <p>La Empresa podrá transferir sus datos personales únicamente en los casos permitidos por la ley, tales como:</p>
    <ul>
        <li>Autoridades competentes cuando sea legalmente requerido</li>
        <li>Proveedores de servicios necesarios para la operación, bajo acuerdos de confidencialidad</li>
    </ul>

    <p>En ningún caso se venderán, rentarán o cederán sus datos personales a terceros sin su consentimiento, salvo disposición legal.</p>

    <br />
    <h5>5. DERECHOS ARCO</h5>

    <p>Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse al tratamiento de sus datos personales.</p>

    <p>Para ejercer estos derechos, deberá enviar una solicitud a través de los medios de contacto disponibles en el sitio web de Legacy Timepieces, indicando su nombre completo, la relación con la Empresa, el derecho que desea ejercer y el medio para recibir respuesta.</p>

    <p>La Empresa dará respuesta conforme a los plazos establecidos por la ley.</p>

    <br />
    <h5>6. USO DE COOKIES Y TECNOLOGÍAS SIMILARES</h5>

    <p>El sitio web operado bajo el nombre comercial Legacy Timepieces puede utilizar cookies y tecnologías similares para mejorar la experiencia del usuario, analizar tráfico y personalizar contenido.</p>

    <p>El usuario puede deshabilitar estas tecnologías desde la configuración de su navegador.</p>

    <br />
    <h5>7. MEDIDAS DE SEGURIDAD</h5>

    <p>La Empresa implementa medidas de seguridad administrativas, técnicas y físicas para proteger los datos personales contra daño, pérdida, alteración, destrucción o uso no autorizado.</p>

    <br />
    <h5>8. CAMBIOS AL AVISO DE PRIVACIDAD</h5>

    <p>La Empresa se reserva el derecho de modificar o actualizar el presente Aviso de Privacidad en cualquier momento. Las modificaciones estarán disponibles en el sitio web operado bajo el nombre comercial Legacy Timepieces.</p>

    <br />
    <h5>9. CONSENTIMIENTO</h5>

    <p>Al proporcionar sus datos personales por cualquier medio, usted reconoce haber leído y aceptado el presente Aviso de Privacidad.</p>

  </div>
</template>

<script>
export default {
}
</script>
